import Table from '@/common/components/Table'
import { DatePickerWithRange } from '@/common/components/ui/dateRangePicker'
import {
  establishmentTotalizerFeesColumns,
  establishmentTotalizerProductsColumns,
} from '@/features/establishments/constants/establishmentTotalizerDefaultColumns.constant'
import useEstablishmentMovementsTotalizer from '@/features/establishments/hooks/useEstablishmentMovementsTotalizer'
import { EstablishmentMovementsTransformer } from '@/features/establishments/services/movementsTransformer'
import { EstablishmentMovementsTotalizerData } from '@/features/establishments/types/establishmentMovementsTotalizer.type'
import { useParams } from 'react-router-dom'
import ResumeList from './components/ResumeList'
import { useFilterParams } from '@/common/hooks/useFilterParams';
import { useFilterDate } from '@/common/hooks/useFilterDate';
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'

const Totals = () => {
  const { id } = useParams();

  const { filterParams, setFilterParams } = useFilterParams();
  const { date, formattedDate } = useFilterDate(filterParams);

  const {
    data: movementsTotalizer,
    isFetching: movementsTotalizerIsFetching,
    error: establishmentMovementsTotalizerError = {} as any,
    refetch: refetchEstablishmentMovementsTotalizer,
  } =
    useEstablishmentMovementsTotalizer<EstablishmentMovementsTotalizerData>({
      filters: {
        id: id || '',
        startDate: formattedDate.from,
        endDate: formattedDate.to,
      },
    });

  if (!id) {
    return null;
  }

  return (
    <ErrorMessageWrapper
      className="h-[calc(100vh-192px)]"
      statusCode={establishmentMovementsTotalizerError?.status}
      refetchFunction={refetchEstablishmentMovementsTotalizer}
    >
      <div className="flex flex-col gap-6 h-[calc(100vh-192px)] overflow-y-auto pr-1">
        <div className="flex items-center gap-4">
          <DatePickerWithRange date={date} setDate={(date) => setFilterParams((prev) => ({ ...prev, date }))} />
        </div>

        <ResumeList data={movementsTotalizer} />

        <div className="space-y-2">
          <p>Produtos</p>
          <Table
            className={`max-h-[calc(280px)] min-h-[${Math.min(
              100 + (movementsTotalizer?.product_movements?.length || 0 * 56),
              256,
            )}px]`}
            columns={establishmentTotalizerProductsColumns}
            isLoadingData={movementsTotalizerIsFetching}
            page={1}
            rows={
              EstablishmentMovementsTransformer.productsTableTransformer()(movementsTotalizer.product_movements) || []
            }
            rowEmptyValue="--"
            totalPages={1}
            totalCount={movementsTotalizer.product_movements?.length || 0}
          />
        </div>

        <div className="space-y-2">
          <p>Tarifas</p>
          <Table
            className={`max-h-[calc(280px)] min-h-[${Math.min(
              100 + (movementsTotalizer?.fees?.length || 0 * 56),
              256,
            )}px]`}
            columns={establishmentTotalizerFeesColumns}
            isLoadingData={movementsTotalizerIsFetching}
            page={1}
            rows={EstablishmentMovementsTransformer.feesTableTransformer()(movementsTotalizer.fees) || []}
            rowEmptyValue="--"
            totalPages={1}
            totalCount={movementsTotalizer.fees?.length || 0}
          />
        </div>

        <div className="space-y-2">
          <p>Tarifas Especiais</p>
          <Table
            className={`max-h-[calc(280px)] min-h-[${Math.min(
              100 + (movementsTotalizer?.special_fees?.length || 0 * 56),
              256,
            )}px]`}
            columns={establishmentTotalizerFeesColumns}
            isLoadingData={movementsTotalizerIsFetching}
            page={1}
            rows={EstablishmentMovementsTransformer.feesTableTransformer()(movementsTotalizer.special_fees) || []}
            rowEmptyValue="--"
            totalPages={1}
            totalCount={movementsTotalizer.special_fees?.length || 0}
          />
        </div>
      </div>
    </ErrorMessageWrapper>
  )
}

export default Totals
